import React from 'react';
import {
  IParticipantSectionsContext,
  ParticipantSectionsContext,
} from './ParticipantSectionsContext';

export const ParticipantSectionsProvider: React.FC<IParticipantSectionsContext> = (
  props,
) => {
  return (
    <ParticipantSectionsContext.Provider
      value={{
        isListParticipantSectionsRequestInProgress:
          props.isListParticipantSectionsRequestInProgress,
        listParticipantSections: props.listParticipantSections,
        getParticipantSections: props.getParticipantSections,
        updateParticipantSections: props.updateParticipantSections,
      }}
    >
      {props.children}
    </ParticipantSectionsContext.Provider>
  );
};
